import { render, staticRenderFns } from "./JobDetailPage.vue?vue&type=template&id=5f648a14&scoped=true&"
import script from "./JobDetailPage.vue?vue&type=script&lang=js&"
export * from "./JobDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./JobDetailPage.vue?vue&type=style&index=0&id=5f648a14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f648a14",
  null
  
)

export default component.exports